import { LogoutResult } from "../interfaces/logout.interface";
import { RegisterPayload, RegisterResult } from "../interfaces/register.interface";
import { ResetPasswordPayload } from "../interfaces/reset-password.interface";
import { SendResetPasswordEmailPayload } from "../interfaces/send-reset-password-email.interface";
import {
  VerifyResetPasswordTokenPayload,
  VerifyResetPasswordTokenResult,
} from "../interfaces/verify-reset-password-token.interface";
import laravelPublicAxiosClient from "../laravelPublicAxiosClient";

export const register = async (payload: RegisterPayload) => {
  const { data } = await laravelPublicAxiosClient.post<RegisterResult>("/auth/register", payload);
  return data;
};

export const verifyResetPasswordToken = async (payload: VerifyResetPasswordTokenPayload) => {
  const { data } = await laravelPublicAxiosClient.post<VerifyResetPasswordTokenResult>(
    "/auth/verify-reset-password-token",
    payload
  );
  return data;
};

export const logout = async () => {
  const laravelToken = localStorage.getItem("lt");
  const { data } = await laravelPublicAxiosClient.post<LogoutResult>(
    "/auth/logout",
    {},
    {
      headers: {
        Authorization: `Bearer ${laravelToken ?? ""}`,
      },
    }
  );
  return data;
};

export const resetPassword = async (payload: ResetPasswordPayload) => {
  await laravelPublicAxiosClient.post<void>("/auth/reset-password", payload);
};

export const sendResetPasswordEmail = async (payload: SendResetPasswordEmailPayload) => {
  await laravelPublicAxiosClient.post<void>("/auth/send-reset-password-email", payload);
};
